import { ActionsUnion, createAction } from "../definitions";
import { ErrorActionTypes, IOfflineErrorPayload } from "./types";

// eslint-disable-next-line @typescript-eslint/naming-convention
export const ErrorActions = {
    setOfflineError: (payload: IOfflineErrorPayload) => createAction(ErrorActionTypes.SET_OFFLINE_ERROR, payload),
    clearOfflineError: () => createAction(ErrorActionTypes.CLEAR_OFFLINE_ERROR)
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type ErrorActions = ActionsUnion<typeof ErrorActions>;